export default __webpack_public_path__ + "static/B0269-23660a9914a2f6107bc950e38f212361.png";